/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgProducts = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m12 2.878 5.5 2.794v4.572l4.5 2.285v5.799l-5.5 2.794-4.5-2.286-4.5 2.286L2 18.328v-5.799l4.5-2.285V5.672zm-4.5 9.1-2.292 1.165L7.5 14.307l2.292-1.164zm3.5 2.794-2.5 1.27v2.328L11 17.1zm2 2.329 2.5 1.27v-2.329l-2.5-1.27zm1.208-3.958 2.292 1.164 2.292-1.164-2.292-1.164zm1.292-2.9V7.916L13 9.185v2.328zm-4.5 1.27V9.185l-2.5-1.27v2.329zM9.708 6.286 12 7.45l2.292-1.164L12 5.122zM20 14.772l-2.5 1.27v2.328L20 17.1zM6.5 18.371v-2.329L4 14.772v2.329z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgProducts as Products };
